import React,{ useContext } from 'react';
import SimpleContext from './../../context/SimpleContext';
import FreshSearchProduct from './FreshSearchProduct';

const FreshSearchProducts = () => {

    const context = useContext(SimpleContext);

    return ( 
        <div className='Searchproducts'>
            <div className="otherPagesHeader">
                <div className="headersNames">
                    <h6 style={{margin:"0", wordSpacing:"-2px"}}>نتایج جست و جو : {context.freshSearchtxt}</h6>
                </div>
            </div>
            <div className="freshProductsMain">
                {
                    context.FreshListFSearch.map(fr=>
                        <div className="freshProductDiv">
                            <FreshSearchProduct 
                                name={fr.lev2Name}
                                image={fr.ImgUrl}
                                id={fr.ID}
                            />

                        </div>
                        )
                }
            </div>
                                
            </div> 
     );
}
 
export default FreshSearchProducts;